import { BANNER_CONTENT } from "./contentRoutes";
import strapiApi from "./strapiApi";

export const getBannerContentData = async () => strapiApi.get(BANNER_CONTENT);
    